import { useParams } from "react-router";

// FIXME: This is a temporary solution to avoid useless re-renders of `useBoard` / `useWorkspace` hooks at every url
//  changes. `tanstack/react-router` seems to provide built-in solution for this, but this requires to migrate
//  completely our routing system to this library.
export const useRouterParam = (paramName: string) => {
  const params = useParams();
  return params[paramName] ?? null;
};
